<template>
  <div>
    <v-toolbar dense>
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-toolbar-title>Procesos</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-text-field
        ml-4
        class="pr-4"
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>

      <v-btn icon small>
        <v-icon>mdi-plus-circle</v-icon>
      </v-btn>
      <v-btn icon small>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <div class="text-h5">Procesos</div> -->
    <div v-on:dragover="allowDrop" v-on:drop="drop">
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0"
        :search="search"
        fixed-header
        dense
      >
        <template v-slot:item.codigo="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.codigo
          }}</v-skeleton-loader>
        </template>
        <template v-slot:item.entidad="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.entidad
          }}</v-skeleton-loader>
        </template>
        <template v-slot:item.objeto_proceso="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.objeto_proceso
          }}</v-skeleton-loader>
        </template>
        <template v-slot:item.tipo_contratacion="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.tipo_contratacion
          }}</v-skeleton-loader>
        </template>
        <template v-slot:item.presupuesto_referencial="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.presupuesto_referencial
          }}</v-skeleton-loader>
        </template>
        <template v-slot:item.estado="{ item }">
          <v-skeleton-loader :loading="!item.codigo" type="list-item">{{
            item.estado
          }}</v-skeleton-loader>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import * as fb from '@/firebase';
import { agregarProceso } from '@/api/procesos';

export default {
  data() {
    return {
      search: '',
      headers: [
        { text: 'No.', value: 'item_no' },
        {
          text: 'Codigo',
          align: 'start',
          sortable: false,
          value: 'codigo'
        },
        { text: 'Entidad', value: 'entidad' },
        { text: 'Objeto Proceso', value: 'objeto_proceso' },
        { text: 'Tipo Contratación', value: 'tipo_contratacion' },
        { text: 'Pres. Ref', value: 'presupuesto_referencial' },
        { text: 'Estado Portal', value: 'estado' }
      ],
      items: []
    };
  },
  methods: {
    async fetchItems() {
      await fb.procesosCollection
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            const proceso = doc.data();
            proceso.id = doc.id;
            console.log('forEarch:', proceso);
            //proceso.codigo = doc.codigo
            this.items.push(proceso);
          });
        })
        .catch(error => {
          console.error(error);
        });
      //console.debug('fetchUser return: ', this.users)  // => at this point, this.users is not yet ready.
    },
    allowDrop: function(event) {
      event.preventDefault();
    },
    drop: function(event) {
      event.preventDefault();
      var data = event.dataTransfer.getData('Text');
      console.log(data);
      agregarProceso({ url: data });
    }
  },
  created() {
    this.fetchItems();
  }
};
</script>
